import { gql } from '@apollo/client';

export const GET_REGISTER_LOG_HISTORY_WITHOUT_AUTH = gql`
  query getRegisterLogHistoryWithoutAuth($id: ID!, $token: String!) {
    getRegisterLogHistoryWithoutAuth(id: $id, token: $token) {
      id
      status
      approvalType
      levelName
      levelNumber
      isRfiStage
      hasProjectAccess
      projectId
      tenantId
      approvalPendingCount
      register {
        id
        name
        projectRegisterId
        registerDetails {
          id
          name
          type
          options
          isRequired
          sequence
        }
        registerFormFields {
          id
          name
          type
          options
          isRequired
          sequence
        }
        project {
          id
          name
          timeZone
        }
      }
      registerLog {
        id
        name
        createdAt
        registerDetailEntries {
          id
          registerDetailId
          value
        }
        registerFormFieldEntries {
          id
          registerFormFieldId
          value
          rowIndex
        }
      }
      projectRegisterApprovals {
        id
        levelNumber
        externalUserApproverId
        internalApproverId
        externalUserApprover {
          id
          name
        }
        internalApprover {
          id
          user {
            id
            name
          }
        }
      }
      comments {
        id
        fieldId
        fieldType
        rowIndex
        remark
        images
        audios
        createdBy {
          id
          name
        }
        createdAt
      }
      byPassRemark
      byPassedImages
      byPassedAudios
    }
  }
`;

export const PROJECT_INSPECTOR_LIST = gql`
  query projectInspectorList($filter: UserFilter!) {
    projectInspectorList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;

export const PROJECT_REGISTER_AGENCY_LIST = gql`
  query projectRegisterAgencyList($filter: ProjectAgencyFilter!) {
    projectRegisterAgencyList(filter: $filter) {
      total
      data {
        id
        agency {
          name
        }
      }
    }
  }
`;

export const PROJECT_AGENCY_CONTACT_LIST = gql`
  query projectAgencyContactList($filter: ProjectAgencyFilter) {
    projectAgencyContactList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;

export const GET_REGISTER_LOG_TO_VALIDATE_APPROVAL = gql`
  query GetRegisterLogToValidateApproval($registerLogId: ID!) {
    getRegisterLogToValidateApproval(registerLogId: $registerLogId) {
      id
      status
      registerVersion
      currentApprovalLevel
      currentApprovalName
      submittedForApprovalAt
      createdAt
      updatedAt
      submitter {
        name
      }
      register {
        name
      }
      project {
        timeZone
      }
      unifiedApprovalHistory {
        levelNumber
        levelName
        status
        approvers
        createdAt
      }
      registerLogHistories {
        approvalStatus
        comments {
          commentText
          assetUrls
        }
        createdAt
        levelName
        levelNumber
        actor {
          name
        }
      }
    }
  }
`;
